module.exports = __webpack_public_path__ + "static/media/06-check.02f93d81.png";